export default __webpack_public_path__ + "static/media/ic_chevron_down_primary.01d75add.svg";